import { Stack, Typography } from "@mui/material";
import TableUse from "components/Atoms/SharedComponents/CRUD/table-use";
import CActions from "components/Molecules/Crud/components/actions";
import DeleteModal from "components/Molecules/Models/DeleteModal";
import React, { useState, useCallback } from "react";
import { useEffect } from "react";
import { useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import { getOrdersRequest } from "services/modules/orders";
import dayjs from "dayjs";
import { useThemePalette } from "common/hooks/theme_palette";
import { useTranslation } from "react-i18next";

export default function OrderHistory() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const list = useSelector((state) => state.orders.orders);
  const count = useSelector((state) => state.orders.count);
  const { oliveGreen } = useThemePalette();
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [tableData, setTableData] = useState({});
  const [page, setPage] = useState(1);
  let [searchParams] = useSearchParams();
  const id = searchParams.get("id");
  const [anchorEl, setAnchorEl] = useState(null);
  const anchorRef = useRef(null);
  const open = Boolean(anchorEl);

  const orderStatuses = {
    processing: { id: 1, name: t("orders.processing") },
    start_route_assigned: { id: 2, name: t("orders.start_route_assigned") },
    started: { id: 3, name: t("orders.started") },
    collected: { id: 4, name: t("orders.collected") },
    ready_for_delivery: { id: 5, name: t("orders.ready_for_delivery") },
    finish_route_assigned: {
      id: 6,
      name: t("orders.finish_route_assigned_label"),
    },
    enroute: { id: 7, name: t("orders.enroute") },
    delivered: { id: 8, name: t("orders.delivered") },
    canceled: { id: 9, name: t("orders.canceled") },
  };
  const [filterObj, setFilterObj] = useState(null);

  const columns = [
    { accessor: "id", Header: t("complaints.col_id") || "#" },
    { accessor: "order_number", Header: t("orders.order_number") },
    {
      accessor: "total",
      Header: t("orders.total"),
      sort: true,
    },
    {
      accessor: "payment_method.name",
      Header: t("orders.payment_method"),
    },
    { accessor: "date", Header: t("orders.date"), sort: true },
    { accessor: "order_type", Header: t("orders.order_type"), sort: true },
    {
      accessor: "status",
      Header: t("orders.order_status"),
    },
    { accessor: "Actions", Header: t("orders.action") },
  ];

  const actionsList = ({ index, data }) => {
    return [
      {
        condition: () => {
          return true;
        },
        click: () => {
          navigate(`/orders?type=details&id=${data?.id}`);
        },
        text: (
          <Typography color={oliveGreen}>{t("orders.view_details")}</Typography>
        ),
      },
    ];
  };

  const filterList = [
    {
      type: "search",
      placeholder: t("orders.search_placeholder"),
      onChange: (value) =>
        setFilterObj((s) => {
          return { ...s, keyword: value?.trim(), page_number: 1 };
        }),
      setFilterObj,
    },
    {
      type: "filter",
      placeholder: t("orders.payment_methods"),
      onChange: (value) => {
        setFilterObj((s) => {
          return { ...s, payment: value?.value, page_number: 1 };
        });
      },
      options: [{ id: 1, name: t("orders.cash") }],
    },
    {
      type: "filter",
      placeholder: t("orders.order_status"),
      onChange: (value) => {
        setFilterObj((s) => {
          return { ...s, status: value?.value, page_number: 1 };
        });
      },
      options: Object.values(orderStatuses),
    },
    {
      type: "filter",
      placeholder: t("orders.order_type"),
      onChange: (value) => {
        setFilterObj((s) => {
          return { ...s, order_type: value?.value, page_number: 1 };
        });
      },
      options: [
        { id: "received", name: t("orders.received") },
        { id: "purchased", name: t("orders.purchased") },
      ],
    },
  ];

  const rowData = (data) => {
    // setSelectedRow(data);
  };

  const handlePageChange = (page) => {
    setPage(page);
    setFilterObj((prev) => {
      return { ...prev, page_number: page };
    });
  };

  const handleDelete = () => {};

  const handleClick = (event, index, data) => {
    anchorEl === index ? setAnchorEl(null) : setAnchorEl(index);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const Actions = (id, elmIndex, data) => {
    return (
      <CActions
        id={id}
        index={elmIndex}
        data={data}
        handleClick={handleClick}
        handleClose={handleClose}
        anchorRef={anchorRef}
        open={open}
        anchorEl={anchorEl}
        actionsList={actionsList}
      />
    );
  };

  const mappedData = list?.map((data, index) => {
    return {
      ...data,
      total: <>{data?.amount} SAR </>,
      date: <>{dayjs(data?.created_at).format("DD-MM-YYYY,hA")} </>,
      Actions: Actions(data?.id, index, data),
    };
  });

  const headerChildren = [];

  const getList = useCallback(
    async (filterObj) => {
      const requestData = {
        params: {
          page_size: 10,
          page_number: 1,
          keyword: "",
          sort_by: "id",
          active_customer_id: id,
          customer_order: true,
          ...filterObj,
        },
      };
      dispatch(getOrdersRequest(requestData));
    },
    [dispatch, id],
  );

  useEffect(() => {
    if (filterObj) getList(filterObj);
  }, [filterObj, getList]);

  useEffect(() => {
    rowData({ ...tableData });
  }, [tableData]);

  return (
    <Stack sx={{ backgroundColor: "white", p: "20px" }}>
      <DeleteModal
        open={openDeleteModal}
        setOpen={setOpenDeleteModal}
        handelDeleteRequest={() => {
          handleDelete(tableData?.rowData?.id && tableData?.rowData?.id);
        }}
        handleCancelDelete={() => setOpenDeleteModal(false)}
        customClass="organizations-delete-modal"
        text={[t("complaints.delete_title"), t("complaints.delete_confirm")]}
      />
      <TableUse
        list={mappedData}
        columnsData={columns}
        setTableData={setTableData}
        setFilterObj={setFilterObj}
        filterList={filterList}
        headerChildren={headerChildren}
        actionsList={actionsList}
        rowData={rowData}
        openDeleteModal={openDeleteModal}
        setOpenDeleteModal={setOpenDeleteModal}
        handlePageChange={handlePageChange}
        paginationPage={page}
        total_count={count}
        path={"orders"}
      />
    </Stack>
  );
}
